import { createContext, useMemo } from "react";

import BorrowAndRepay from "components/BorrowAndRepay";
import Transfer from "components/Transfer";
import { useSearchParams } from "react-router-dom";

export const GlobalModalsContext = createContext();

function GlobalModalsProvider({ children }) {
  const [searchParams, setSearchParams] = useSearchParams();

  const borrow = !!searchParams.get("borrow");
  const repay = !!searchParams.get("repay");
  const transfer = !!searchParams.get("transfer");

  const showBorrow = useMemo(() => borrow, [borrow]);

  const showRepay = useMemo(() => repay, [repay]);

  const showTransfer = useMemo(() => transfer, [transfer]);

  const handleCloseCommonModal = (name, extra) => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    delete allSearchParams[name];
    if (extra) {
      delete allSearchParams[extra];
    }

    setSearchParams({ ...allSearchParams });
  };

  return (
    <GlobalModalsContext.Provider
      value={{ showBorrow, showRepay, showTransfer }}
    >
      {children}

      {showBorrow && (
        <BorrowAndRepay
          open={showBorrow}
          onClose={() => handleCloseCommonModal("borrow")}
        />
      )}

      {showRepay && (
        <BorrowAndRepay
          open={showRepay}
          onClose={() => handleCloseCommonModal("repay")}
        />
      )}

      {showTransfer && (
        <Transfer
          open={showTransfer}
          onClose={() => handleCloseCommonModal("transfer", "transferSideId")}
        />
      )}
    </GlobalModalsContext.Provider>
  );
}

export default GlobalModalsProvider;
